import { useState, useEffect } from "react";
import dayjs from "dayjs";

export function useWorkingHoursForm(edit: boolean, editData: any) {
  const [selectedWeekDays, setSelectedWeekDays] = useState<number[]>([]);
  const [initialValues, setInitialValues] = useState<any>();
  const [itemsInitialValues, setItemsInitialValues] = useState<any>();

  useEffect(() => {
    if (edit) {
      if (!editData) throw new Error("editData is required");
      else if (
        initialValues?.name !== editData.name ||
        !selectedWeekDays.length
      ) {
        const selectedWeekDays: number[] = Array.from(
          new Set(editData?.items?.map((item: any) => item.weekday))
        );

        setSelectedWeekDays([...selectedWeekDays]);
        const items = editData?.items?.reduce((acc: any, item: any) => {
          acc[item.weekday] = acc[item.weekday] || [];
          acc[item.weekday].push({
            timeRange: [
              dayjs(item.startTime, "HH:mm"),
              dayjs(item.endTime, "HH:mm"),
            ],
          });
          return acc;
        }, {});
        setItemsInitialValues(items);
        setInitialValues({
          name: editData?.name || "",
          nameAr: editData?.nameAr || "",
          priority: `${editData?.priority}` || "",
          period: [
            editData?.startDate
              ? dayjs(editData.startDate, "YYYY-MM-DD")
              : null,
            editData?.endDate ? dayjs(editData.endDate, "YYYY-MM-DD") : null,
          ],
          stores: editData?.stores?.map((store: any) => store.id) || [],
        });
      }
    }
  }, [edit, editData, initialValues, selectedWeekDays]);

  return {
    selectedWeekDays,
    setSelectedWeekDays,
    initialValues,
    itemsInitialValues,
    ready: edit ? !!initialValues?.name : true,
  };
}
